import { useEffect, useState } from "react";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";

export default function PayPalPay({ artwork }) {
  const [config, setConfig] = useState(null);

  useEffect(() => {
    api
      .get("/paypal/config")
      .then((r) => setConfig(r.data))
      .catch(() => setConfig({ client_id: "", mode: "sandbox" }));
  }, []);

  if (!config) return null;
  if (!config.client_id || !artwork.price || artwork.sold) return null;

  return (
    <div className="mt-8" data-testid="paypal-section">
      <div className="flex items-center gap-3 mb-4">
        <span className="h-px flex-1 bg-line" />
        <p className="eyebrow">Buy Now with PayPal</p>
        <span className="h-px flex-1 bg-line" />
      </div>
      <PayPalScriptProvider
        options={{ clientId: config.client_id, currency: "USD", intent: "capture", environment: config.mode === "live" ? "production" : "sandbox" }}
      >
        <PayPalButtons
          style={{ color: "gold", layout: "horizontal", shape: "rect", label: "paypal", height: 48 }}
          createOrder={async () => {
            try {
              const { data } = await api.post("/paypal/orders", { artwork_id: artwork.id });
              return data.id;
            } catch (err) {
              toast.error(errMsg(err, "Could not start the PayPal checkout"));
              throw err;
            }
          }}
          onApprove={async (approval) => {
            try {
              const { data } = await api.post(`/paypal/orders/${approval.orderID}/capture`);
              if (data.status === "COMPLETED")
                toast.success("Payment received — thank you. The studio will be in touch shortly.");
              else toast.info(`Payment status: ${data.status}`);
            } catch (err) {
              toast.error(errMsg(err, "Payment captured but could not be confirmed — the studio will verify"));
            }
          }}
          onError={() => {
            toast.error("PayPal had trouble completing the payment — please try again");
          }}
        />
      </PayPalScriptProvider>
      {config.mode === "sandbox" && (
        <p
          className="font-meta text-[9px] uppercase tracking-[0.25em] text-mute mt-3 text-center"
          data-testid="paypal-sandbox-note"
        >
          Sandbox test mode — no real money moves
        </p>
      )}
    </div>
  );
}
